import { render, staticRenderFns } from "./TransactionStatusTag.vue?vue&type=template&id=c4a398e4&"
import script from "./TransactionStatusTag.vue?vue&type=script&lang=js&"
export * from "./TransactionStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./TransactionStatusTag.vue?vue&type=style&index=0&id=c4a398e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports